import {Component, OnInit} from '@angular/core';
import {FormBuilder, FormGroup, FormsModule, ReactiveFormsModule, Validators} from "@angular/forms";
import {ImageCropperModule} from "ngx-image-cropper";
import {NgForOf} from "@angular/common";
import {DocumentsService} from "../../../services/document.service";
import {ClaseModel, tiposClases} from "../../../models/clase.model";
import Swal from "sweetalert2";
import {environment} from "../../../../environments/environment";
import {PlantillaModel} from "../../../models/plantilla.model";
import {DomSanitizer} from "@angular/platform-browser";
import { QuillModule } from 'ngx-quill';
import { CommonModule } from '@angular/common';
declare var $: any;
import Quill from 'quill';
import ImageResize from 'quill-image-resize-module';
Quill.register('modules/imageResize', ImageResize);
@Component({
  selector: 'app-plantillas',
  standalone: true,
  imports: [
    FormsModule,
    ImageCropperModule,
    ReactiveFormsModule,
    NgForOf,
    QuillModule,
    CommonModule
  ],
  templateUrl: './plantillas.component.html',
  styleUrl: './plantillas.component.css'
})

export class PlantillasComponent implements OnInit {
  quillModules = {
    imageResize: true, // Activar redimensionamiento de imágenes
  };
  
  formPlantilla: FormGroup;
  listaPlantillas: ClaseModel[] = [];
  editarPlantilla: any = false;
  userInfo: any;
  plantillaSeleccionada: any = '';
  plantillaSeleccionadaEditar: any = '';

  pattern = 'plantilla'

  constructor(private fb: FormBuilder,
              private documentService: DocumentsService,
              private sanitizer: DomSanitizer) {
    this.formPlantilla = this.fb.group
    ({
      nombrePlantilla: ['', [Validators.required]],
      contenidoPlantilla: [''],
    })
  }

  ngOnInit() {
    $('#sidebar-overlay').click();

    this.editarPlantilla = false;
    this.userInfo = JSON.parse(localStorage.getItem('userData'));
    /*$('.textarea').summernote(
        $('.textarea').eq(0).html(''),
    )*/
    this.getPlantillasByEmpresa();
  }

  modalPlantilla(){
    console.log('plantilla nueva')
    $(".textarea").summernote('destroy');
    $('.textarea').summernote()
    $("#modal-nuevaPlantilla").modal({ backdrop: "static", keyboard: false });
    $("#modal-nuevaPlantilla").modal("show");
  }

  modalEditarPlantilla()
  {
    let plantilla = this.plantillaSeleccionadaEditar;
    console.log(plantilla)
    this.editarPlantilla = plantilla;
    this.formPlantilla.patchValue({
      nombrePlantilla: plantilla.nombrePlantilla,

      contenidoPlantilla: plantilla.contenidoPlantilla,
      idEmpresa: plantilla.idEmpresa,
    })

    this.modalPlantilla();
  }

  modalPreviewPlantilla(plantilla){
    // debugger
    console.log(plantilla.contenidoPlantilla)
    //this.plantillaSeleccionada = plantilla.contenidoPlantilla
    this.plantillaSeleccionadaEditar = plantilla;
    this.plantillaSeleccionada = this.sanitizer.bypassSecurityTrustHtml(plantilla.contenidoPlantilla);

  }

  cleanPreview(){
    this.plantillaSeleccionada = ''
  }

  createOrUpdatePlantillaFn(){
    //this.submitFormClases = true;
    if(this.formPlantilla.invalid || $('.textarea').summernote('code') == '')
    {
      Swal.fire('Advertencia', 'Verifica que los campos sean válidos.', 'warning');
      return;
    }

    let plantillaDocContModel: PlantillaModel = {
      nombrePlantilla: this.formPlantilla.get('nombrePlantilla').value,
      contenidoPlantilla: this.formPlantilla.get('contenidoPlantilla').value,
      empresaId: this.userInfo.empresaId,
      activo: true
    };
    console.log(plantillaDocContModel)

    if(this.editarPlantilla) this.updateClaseFn(plantillaDocContModel, this.editarPlantilla);
    if(!this.editarPlantilla) this.createClaseFn(plantillaDocContModel);
    this.formPlantilla.reset();
  }

  createClaseFn(plantillaDocContModel){
    let businessId = environment.businessId;
    let event: any = {}

    this.documentService.createDocumentInContainer(
        businessId,
        this.userInfo.documentContainerId,
        null,
        this.pattern,
        event,
        plantillaDocContModel,
    ).subscribe({
      next: (data) => {
        // debugger
        console.log(data);
        //this.submitFormClases = false;
        Swal.fire({
          position: "top-end",
          icon: "success",
          title: "Plantilla guardada con éxito",
          showConfirmButton: false,
          timer: 1500
        });
        $("#modal-nuevaPlantilla").modal('hide');
        this.getPlantillasByEmpresa();
        this.inicializarFormPlantilla();
      },
      error: (error) => {
        console.error(error);
        //this.loading = false;
      },
    });
  }

  updateClaseFn(plantillaDocContModel: PlantillaModel, infoPlantilla) {
    let title = ''
    if(plantillaDocContModel.activo) title = "Plantilla actualizada con éxito";
    if(!plantillaDocContModel.activo) title = "Plantilla eliminada con éxito";

    let businessId = environment.businessId;
    let event: any = {}
    this.documentService.updateDocumentInContainer(
        businessId,
        infoPlantilla.documentContainerId,
        infoPlantilla.documentId,
        this.pattern,
        event,
        plantillaDocContModel
    ).subscribe({
      next: (data) => {
        console.log(data);
        //this.submitFormClases = false;
        Swal.fire({
          position: "top-end",
          icon: "success",
          title: title,
          showConfirmButton: false,
          timer: 1500
        });
        if(plantillaDocContModel.activo) $("#modal-nuevaPlantilla").modal('hide');
        this.plantillaSeleccionada = this.sanitizer.bypassSecurityTrustHtml(data.contenidoPlantilla);
        this.getPlantillasByEmpresa();
        this.inicializarFormPlantilla();
      },
      error: (error) => {
        console.error(error);
        Swal.fire({
          position: "top-end",
          icon: "error",
          title: "Ocurrió un error al guardar la plantilla.",
          showConfirmButton: false,
          timer: 1500
        });
      },
    });
  }

  inicializarFormPlantilla(){
    this.editarPlantilla = false;
    this.formPlantilla.setValue({
      nombrePlantilla: '',
      contenidoPlantilla: '',
    })
  }

  getPlantillasByEmpresa(){
    this.documentService.getDocumentsByType(
        environment.businessId,
        this.userInfo.documentContainerId,
        "plantilla"
    ).subscribe({
      next: (data: any) => {
        this.listaPlantillas = data.content.sort((a, b) => 
          a.nombrePlantilla.localeCompare(b.nombrePlantilla, 'es', { sensitivity: 'base' })
        );
      },
      error: (error) => {
        console.log(error);
      }
    })

    // const filters: any = {
    //   "empresaId": this.userInfo.empresaId
    // };
    // // GET FILTERS ARRAY
    // let filtersQuery: any = this.documentService.getFiltersArray(filters);
    //
    // const query = {
    //   "sort": [
    //     {
    //       "esDocumentDate": {
    //         "order": "desc",
    //         "unmapped_type": "boolean"
    //       }
    //     }
    //   ],
    //   "size": 200,
    //   "query": {
    //     "bool": {
    //       "must": [],
    //       "filter": filtersQuery,
    //       "should": [],
    //       "must_not": []
    //     }
    //   }
    // };
    // setTimeout(() => {
    //   this.documentService.searchDocument(environment.businessId, this.pattern, query).subscribe({
    //     next: (data: any) => {
    //       console.log(data)
    //       debugger
    //       //let newarr = data.sort((a, b) => a.nombrePlantilla < b.nombrePlantilla);
    //       this.listaPlantillas = data.sort((a, b) => (a.nombrePlantilla > b.nombrePlantilla) ? 1 : -1)
    //
    //     },
    //     error: (error: any) => {
    //       console.error(error);
    //     }
    //   });
    // }, 900);

  }

  protected readonly tiposClases = tiposClases;
}
